export default {
  sessionsList: [],
  manageSession: {}
}
